export default function LuckyRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h2 {
                        font-size: 33px;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>

            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>7 Up and 7 Down</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">The objective of 7 Up and 7 Down is to correctly predict whether the next card drawn from the deck will be higher or lower than or equal to a designated starting card.</p>
                                        </div>
                                        <div>
                                            <h3><b>Winning and Payouts:</b></h3>
                                            <p class="pt20">Betting on the correct outcome (7 Up or 7 Down) typically pays 1:1, which means you win an amount equal to your bet.</p>
                                            <p class="pt20">Betting on the outcome `7` pays 10.5:1.</p>
                                        </div>
                                        <div>
                                            <h3><b>Materials</b></h3>
                                            <p class="pt20">A standard deck of 52 playing cards. </p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20">The game starts with each player placing their bets on the table. Players can bet on whether the next card will be higher (7 Up) or lower (7 Down) than the starting card.</p>
                                            <p class="pt20">After all bets are placed, the dealer draws the next card from the deck and places it face up next to the starting card.</p>

                                            <p class="pt20">If the drawn card matches the prediction made by the player, they win. If their prediction is incorrect, they lose their bet.</p>
                                            <p class="pt20">Cards are ranked in the standard poker hierarchy: Ace (low) to King (high).</p>
                                        </div>
                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


        </>
    );
}